"use client";
import { IFreelanceSpecsFields } from "@/lib/contentful/generated/contentful";

import styles from "./FreelanceSpecs.module.css";
import { cn } from "@boostdev/design-system-components/utils";
import Link from "next/link";
import { Fragment } from "react";
import { Icon } from "@/components/atoms/Icon/Icon";
import { IconType, IconTypes } from "@/components/atoms/Icon/Icon.types";
import { Button } from "@/components/atoms/Button/Button";

interface FreelanceSpecsProps {
  freelanceSpecs: { fields: IFreelanceSpecsFields }[];
  className?: string;
  /** Server-translated label for the call CTA. Passed in so the rendered
   *  HTML matches the route's locale on first paint (the previous client-only
   *  translation hydrated to the fallback language during SSR). */
  callMeLabel: string;
}

export function FreelanceSpecs({
  freelanceSpecs,
  className = "",
  callMeLabel,
}: Readonly<FreelanceSpecsProps>) {
  const handlePhoneNumberClick = () => {
    window.location.href = "tel:0641882433";
  };

  return (
    <div className={cn([styles.wrapper, className])}>
      <dl className={styles.list}>
        {freelanceSpecs.map((item) => {
          const fields = item.fields;
          let href = "";
          let label = fields.label;
          if (fields.label.includes("https://")) {
            href = fields.label;
            label = fields.iconAlt ?? "";
          }
          return (
            <Fragment key={`fields-${fields.label}`}>
              <dt className={styles.iconWrapper}>
                <Icon
                  type={fields.iconName as IconType}
                  className={styles.icon}
                  title={fields.iconAlt}
                />
              </dt>
              <dd className={styles.label}>
                {href ? (
                  <Link href={href} className={styles.linkLabel}>
                    {fields.iconAlt}
                  </Link>
                ) : (
                  label
                )}
              </dd>
            </Fragment>
          );
        })}
        <dt className={styles.iconWrapper}>
          <Icon
            type={IconTypes.Call}
            className={styles.icon}
            title={callMeLabel}
          />
        </dt>
        <dd className={cn([styles.label, styles.callMeContainer])}>
          <Button
            variant={"secondary"}
            onClick={handlePhoneNumberClick}
            className={styles.callMe}
          >
            {callMeLabel}
          </Button>
        </dd>
      </dl>
    </div>
  );
}
